export default __webpack_public_path__ + "static/2-home-page-1a57ad131f7fcabbfc5d2a993f6b1a9c.jpg";